let country_data = [ // https://www.iconfinder.com/iconsets/ensign-11 - icon pack
    {
        'iso_code': 'us',
        'flag': '/img/flags/usa.svg',
        'country': 'usa',
        'city': ['New York', 'San Francisco', 'Atlanta', 'Chicago', 'Dallas', 'Los Angeles', 'Miami', 'New Jersey', 'Seattle', 'Silicon Valley']
    },
    {
        'iso_code': 'nl',
        'flag': '/img/flags/net.svg',
        'country': 'netherlands',
        'city': ['Amsterdam', 'Rotterdam']
    },
    {
        'iso_code': 'de',
        'flag': '/img/flags/ger.svg',
        'country': 'germany',
        'city': ['Frankfurt', 'Munich']
    },
    {
        'iso_code': 'sg',
        'flag': '/img/flags/sin.svg',
        'country': 'singapore',
        'city': ['Singapore']
    },
    {
        'iso_code': ['uk', 'gb'],
        'flag': '/img/flags/eng.svg',
        'country': 'england',
        'city': ['London', 'Manchester']
    },
    {
        'iso_code': 'ind',
        'flag': '/img/flags/ind.svg',
        'country': 'india',
        'city': ['Bangalore', 'Deli']
    },{
        'iso_code': 'in',
        'flag': '/img/flags/ind.svg',
        'country': 'india',
        'city': ['Mumbai']
    },
    {
        'iso_code': 'ca',
        'flag': '/img/flags/can.svg',
        'country': 'canada',
        'city': ['Toronto', 'Montreal', 'Ottawa']
    },
    {
        'iso_code': 'be',
        'flag': '/img/flags/bel.svg',
        'country': 'belgium',
        'city': ['Brussels', 'Antwerp']
    },
    {
        'iso_code': 'ch',
        'flag': '/img/flags/chi.svg',
        'country': 'china',
        'city': ['Hong Kong', 'Beijing']
    },
    {
        'iso_code': 'jp',
        'country': 'japan',
        'flag': '/img/flags/jap.svg',
        'city': ['Tokyo', 'Okinawa']
    },
    {
        'iso_code': 'fr',
        'flag': '/img/flags/fra.svg',
        'country': 'france',
        'city': ['Paris']
    },
    {
        'iso_code': 'au',
        'flag': '/img/flags/au.svg',
        'country': 'australia',
        'city': ['Sydney']
    },
    {
        'iso_code': ['mex', 'mx'],
        'flag': '/img/flags/mex.svg',
        'country': 'mexico',
        'city': ['Mexico']
    },
    {
        'iso_code': 'bra',
        'flag': '/img/flags/brz.svg',
        'country': 'brazil',
        'city': ['Sao Paulo']
    },
    {
        'iso_code': 'ita',
        'flag': '/img/flags/it.svg',
        'country': 'italy',
        'city': ['Milan']
    },
    {
        'iso_code': 'nor',
        'flag': '/img/flags/nor.svg',
        'country': 'norvegia',
        'city': ['Oslo']
    },
    {
        'iso_code': ['kor', 'kr'],
        'flag': '/img/flags/kr.svg',
        'country': 'south_korea',
        'city': ['Seoul']
    },
    {
        'iso_code': 'irl',
        'flag': '/img/flags/irl.svg',
        'country': 'ireland',
        'city': ['Dublin']
    },
    {
        'iso_code': 'twn',
        'flag': '/img/flags/tw.svg',
        'country': 'taiwan',
        'city': ['Taibao']
    },
    {
        'iso_code': 'fin',
        'flag': '/img/flags/fin.svg',
        'country': 'finland',
        'city': ['Helsinki']
    },
    {
        'iso_code': 'eu',
        'flag': '/img/flags/eu.svg',
        'country': 'europe',
        'city': []
    },
    {
        'iso_code': 'my',
        'flag': '/img/flags/my.svg',
        'country': 'malaysia',
        'city': ['Kuala Lumpur']
    },
    {
        'iso_code': 'id',
        'flag': '/img/flags/id.svg',
        'country': 'indonesia',
        'city': ['Jakarta']
    },
    {
        'iso_code': 'ae',
        'flag': '/img/flags/ae.svg',
        'country': 'United Arab Emirates',
        'city': ['Dubai']
    },
    {
        'iso_code': 'sa',
        'flag': '/img/flags/sa.svg',
        'country': 'South Africa',
        'city': ['Cape Town']
    },
    {
        'iso_code': 'sw',
        'flag': '/img/flags/sw.svg',
        'country': 'Switzerland',
        'city': ['Bern']
    },
    {
        'iso_code': 'se',
        'flag': '/img/flags/se.svg',
        'country': 'Sweden',
        'city': []
    },
    {
        'iso_code': 'esp',
        'flag': '/img/flags/esp.svg',
        'country': 'Spain',
        'city': ['Madrid']
    },
    {
        'iso_code': 'pol',
        'flag': '/img/flags/pol.svg',
        'country': 'Poland',
        'city': ['Warsaw']
    },
];
export default country_data;